import React from 'react'
import PropTypes from 'prop-types'
import { ActionList } from 'material-ui/svg-icons'

const SliderSettingPill = ({
  styles,
  toggleApptTypeDialog,
}) => (
  <div
    onClick={toggleApptTypeDialog}
    role="button"
    style={styles.apptTypePill}
    tabIndex="-1"
    className="slider-appt-pill"
  >
    <ActionList style={styles.apptTypeIcon} />
    <span style={styles.span}>Slider Settings</span>
  </div>
)

SliderSettingPill.propTypes = {
  styles: PropTypes.objectOf(PropTypes.any),
  toggleApptTypeDialog: PropTypes.func,
}

export default SliderSettingPill



// WEBPACK FOOTER //
// ./src/components/Settings/CreateSlider/SliderSettingPill.js